import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Arrange from '../views/Arrange.vue'
import Progress from '../views/Progress.vue'
import Profile from '../views/Profile.vue'
import Payment from '../views/PaymentMethod.vue'
import History from '../views/History.vue'
import Contact from '../views/Contact.vue'
import CurrentDeliveries from '../views/CurrentDeliveries.vue'
import Register from '../views/Registration/Index.vue'
import Complete from '../views/Registration/Complete.vue'
import NotFoundComponent from '../views/NotFoundComponent.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Register',
    component: Register
  },
  {
    path: '/complete',
    name: 'Complete',
    component: Complete
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/arrange/:id',
    name: 'Arrange',
    props: true,
    component: Arrange
  },
  {
    path: '/progress',
    name: 'Progress',
    component: Progress
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/history',
    name: 'History',
    component: History
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/current_deliveries',
    name: 'CurrentDeliveries',
    component: CurrentDeliveries
  },
  { path: '*', component: NotFoundComponent }
]

const router = new VueRouter({
  routes
})

export default router
